<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('leaveRecord.leaveRecord') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('leaveRecord.leaveRecord'),
            href: '/employees'
          },
          {
            text: $t('addNew'),
            active: true
          }
        ]"
      />
    </div>
    <form class="form-horizontal">
      <div class="row">
        <div class="col-lg-3 col-md-5 col-sm-12">
          <ts-card>
            <div id="cover-image">
              <img
                src="http://img.clipartlook.com/office-management-clipart-business-presentation-information-clip-art-vector-business-office-meeting-2694.png"
                alt
              />
              <div id="img-frame" class="text-center mb-1">
                <img
                  v-lazy="{
                    src: photoEmp(profile),
                    error: onError(profile),
                    loading: require('@/assets/Rolling-1s-200px_2.svg')
                  }"
                />
              </div>
            </div>
            <div class="row form-group m-b-15">
              <div class="col-md-12 text-center">
                <span>{{ profile.card_id }}</span>
                <h3 class="text-center ts-font-bold ts-text-lg mt-2 mb-0 text-uppercase text-primary">
                  {{ profile.employee_name_en }}
                </h3>
                <small class="text-center text-default">{{ profile.position_name_en }}</small>
              </div>
            </div>
            <ts-card-wrapper>
              <ul class="list-group list-group-flush">
                <li class="list-group-item">
                  <span>{{ $t('leaveRecord.nameKh') }}</span>
                  <p class="pull-right">{{ profile.employee_name_kh ? profile.employee_name_kh : '-' }}</p>
                </li>
                <li class="list-group-item">
                  <span>{{ $t('leaveRecord.nameEn') }}</span>
                  <p class="pull-right">{{ profile.employee_name_en ? profile.employee_name_en : '-' }}</p>
                </li>
                <li class="list-group-item">
                  <span>{{ $t('leaveRecord.gender') }}</span>
                  <p class="pull-right">{{ profile.sex ? profile.sex : '-' }}</p>
                </li>
                <li class="list-group-item">
                  <span>{{ $t('leaveRecord.dateOfBirth') }}</span>
                  <p class="pull-right">{{ profile.date_of_birth ? profile.date_of_birth : '-' }}</p>
                </li>
                <li class="list-group-item">
                  <span>{{ $t('leaveRecord.shiftName') }}</span>
                  <p class="pull-right">{{ profile.shift_name ? profile.shift_name : '-' }}</p>
                </li>
              </ul>
            </ts-card-wrapper>
          </ts-card>
          <br />
        </div>
        <div class="col-lg-9 col-md-7 col-sm-12">
          <ts-card>
            <ts-loading-banner :loading="loadingPreData">
              <ts-card-wrapper>
                <div class="row form-group m-b-15">
                  <label class="col-sm-3 col-form-label control-label required">{{
                    $t('leaveRecord.employeeName')
                  }}</label>
                  <div class="col-sm-6">
                    <ts-search-select
                      v-model="model.employee_id"
                      @change="getEmployee"
                      :class="{ 'is-invalid': errors.has('employee_id') }"
                      :options="
                        employees.map(emp => ({
                          value: emp.employee_id,
                          text: emp.employee_name_en + ' | ' + emp.employee_name_kh
                        }))
                      "
                    />
                    <div class="invalid-feedback" v-if="errors.has('employee_id')">
                      {{ errors.first('employee_id') }}
                    </div>
                  </div>
                </div>
                <div class="row form-group m-b-15">
                  <label class="col-sm-3 control-label required">{{ $t('leaveRecord.leaveType') }}</label>
                  <div class="col-sm-6">
                    <select
                      class="form-control"
                      v-model="model.leave_type_id"
                      :class="{ 'is-invalid': errors.has('leave_type_id') }"
                      @change="onLeaveType"
                    >
                      <option value disabled selected style="display: none;">{{ $t('select') }}</option>
                      <option v-for="(leave_type, index) in leaveTypes" :key="index" :value="leave_type.leave_type_id"
                        >{{ leave_type.leave_type_en }} | {{ leave_type.leave_type_kh }}</option
                      >
                    </select>
                    <div class="invalid-feedback" v-if="errors.has('leave_type_id')">
                      {{ errors.first('leave_type_id') }}
                    </div>
                  </div>
                </div>
                <div v-if="model.is_allow_sub_item" class="row form-group m-b-15">
                  <label class="col-sm-3 control-label required">{{ $t('leaveRecord.leaveSubItem') }}</label>
                  <div class="col-sm-6">
                    <select
                      class="form-control"
                      v-model="model.leave_sub_item_id"
                      :class="{ 'is-invalid': errors.has('leave_sub_item_id') }"
                    >
                      <option value>--{{ $t('select') }}--</option>
                      <option
                        v-for="(leave_sub_item, index) in leaveSubItems"
                        :key="index"
                        :value="leave_sub_item.leave_sub_item_id"
                        >{{ leave_sub_item.leave_sub_item }}</option
                      >
                    </select>
                    <div class="invalid-feedback" v-if="errors.has('leave_sub_item_id')">
                      {{ errors.first('leave_sub_item_id') }}
                    </div>
                  </div>
                </div>
                <div class="form-group row m-b-15">
                  <label class="col-md-3 col-form-label control-label required">{{ $t('leaveRecord.dateFrom') }}</label>
                  <div class="col-md-6 col-xs-12">
                    <div class="d-flex justify-content-between align-items-center">
                      <ts-date-picker-input
                        v-model="model.date_from"
                        @input="onValueChange"
                        :class="{ 'is-invalid': errors.has('date_from') }"
                      ></ts-date-picker-input>
                      <label class="col-md-4 col-sm-4 col-lg-4 col-form-label control-label required">{{
                        $t('leaveRecord.dateTo')
                      }}</label>
                      <ts-date-picker-input
                        v-model="model.date_to"
                        @input="onValueChange"
                        :disabled="model.leave_type_id == 2"
                        :class="{ 'is-invalid': errors.has('date_to') }"
                      ></ts-date-picker-input>
                    </div>
                  </div>
                </div>
                <div class="form-group row m-b-15">
                  <label class="col-md-3 col-form-label control-label required">{{ $t('leaveRecord.timeFrom') }}</label>
                  <div class="col-md-6 col-xs-12">
                    <div class="d-flex justify-content-between align-items-center">
                      <div class="input-group">
                        <select
                          :class="{ 'is-invalid': errors.has('time_from') }"
                          class="form-control"
                          v-model="model.time_from"
                          @change="onValueChange"
                          :disabled="model.leave_type_id == 2"
                        >
                          <option :value="null" disabled selected style="display: none;">{{ $t('select') }}</option>
                          <option v-for="(time, index) in times" :key="index" :value="time.time_from">{{
                            tConvert(time.time_from)
                          }}</option>
                        </select>
                        <span class="input-group-addon">
                          <span class="fa fa-clock"></span>
                        </span>
                      </div>
                      <label class="col-md-4 col-sm-4 col-lg-4 col-form-label control-label">{{
                        $t('leaveRecord.timeTo')
                      }}</label>
                      <div class="input-group">
                        <select
                          :class="{ 'is-invalid': errors.has('time_to') }"
                          class="form-control"
                          v-model="model.time_to"
                          @change="onValueChange"
                          :disabled="model.leave_type_id == 2"
                        >
                          <option :value="null" disabled selected style="display: none;">{{ $t('select') }}</option>
                          <option v-for="(time, index) in availableTimeTos" :key="index" :value="time.time_to">{{
                            tConvert(time.time_to)
                          }}</option>
                        </select>
                        <span class="input-group-addon">
                          <span class="fa fa-clock"></span>
                        </span>
                      </div>
                    </div>
                  </div>
                  <label v-if="model.total_day" class="col-md-3 text-center text-primary">
                    {{ $t('leaveRecord.totalLeave') }}:
                    {{
                      model.total_day > 1
                        ? model.total_day + $t('leaveRecord.days')
                        : model.total_day + $t('leaveRecord.day')
                    }}
                  </label>
                </div>
                <div class="form-group row m-b-15">
                  <label for="leave_reason" class="col-sm-3 control-label">{{ $t('leaveRecord.leaveReason') }}</label>
                  <div class="col-sm-6">
                    <textarea
                      id="leave_reason"
                      v-model="model.leave_reason"
                      class="form-control"
                      rows="5"
                      :placeholder="$t('leaveRecord.writeReasonHere')"
                    ></textarea>
                  </div>
                </div>
                <hr />
                <div class="row mt-3">
                  <div class="col-md-12 text-right">
                    <ts-button @click.prevent="$router.push({ name: 'leave-record' })">{{
                      $t('button.cancel')
                    }}</ts-button>
                    <ts-button class="btn-primary ml-2" @click.prevent="update" :waiting="saving">{{
                      $t('button.update')
                    }}</ts-button>
                  </div>
                </div>
              </ts-card-wrapper>
            </ts-loading-banner>
          </ts-card>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'
import moment from 'moment'

export default {
  name: 'leave-record-edit',
  data() {
    return {
      model: {
        lr_id: 0,
        employee_id: '',
        leave_type_id: '',
        leave_sub_item_id: '',
        date_from: moment().format('DD-MM-YYYY'),
        date_to: moment().format('DD-MM-YYYY'),
        time_from: null,
        time_to: null,
        total_day: null,
        leave_reason: '',
        is_allow_sub_item: false
      },
      profile: {
        card_id: '',
        employee_name_en: '',
        employee_name_kh: '',
        sex: '',
        position_name_en: '',
        shift_name: '',
        date_of_birth: '',
        photo: '',
        phone: ''
      },
      errors: new Errors(),
      saving: false,
      loadingPreData: false,
      manPhoto: require('../../../assets/staff-default-man.png'),
      womenPhoto: require('../../../assets/staff-default-women.png'),
      user_default: require('../../../assets/user_default.png')
    }
  },
  computed: {
    ...mapState('hr/leaveRecord', ['edit_data', 'employees', 'leaveTypes', 'times', 'leaveSubItems']),
    availableTimeTos() {
      let duration = moment.duration(
        moment(this.model.date_to, 'D-MM-YYYY').diff(moment(this.model.date_from, 'D-MM-YYYY'))
      )

      if (duration._milliseconds > 0) {
        return this.times.filter(el => el.time_to != null)
      } else if (duration._milliseconds < 0) {
        this.$store.commit('hr/leaveRecord/RECEIVE_TIMES', [])
        this.model.time_from = this.model.time_to = null
      } else {
        let time = []
        this.times.forEach(data => {
          time.push(
            Object.assign({}, this.newItem, data, {
              time_to:
                moment(this.tConvert(data.time_to), 'HH:mm a') >
                  moment(this.tConvert(this.model.time_from), 'HH:mm a') || this.model.time_from === null
                  ? data.time_to
                  : null
            })
          )
        })
        return time.filter(el => el.time_to != null)
      }
    }
  },
  created() {
    this.fetchResourceBeforeCreate()
  },
  methods: {
    ...mapActions('hr/leaveRecord', ['fetchEmployees', 'getTimeFromTo', 'fetchLeaveSubItems']),

    onValueChange() {
      this.model.total_day = null
      this.getTimeFromTo(this.model)
      if (this.model.leave_type_id == 2 && this.model.date_from) {
        this.maternityLeave()
      } else {
        this.getTotalDay()
      }
    },

    onLeaveType() {
      this.model.leave_sub_item_id = ''
      this.allowSubItem()
      if (this.model.leave_type_id == 2 && this.model.date_from) {
        this.maternityLeave()
      } else {
        this.getTotalDay()
      }
    },

    allowSubItem() {
      let leave_type = this.leaveTypes.filter(item => item.leave_type_id == this.model.leave_type_id)
      this.model.is_allow_sub_item = leave_type[0].is_allow_sub_item
    },

    async maternityLeave() {
      await this.getTimeFromTo(this.model)
      let new_date = moment(this.model.date_from, 'DD-MM-YYYY')
      this.model.date_to = new_date.add(89, 'days').format('DD-MM-YYYY')
      this.model.time_from = this.times.length > 0 ? this.times[0].time_from : ''
      this.model.time_to = this.times.length > 0 ? this.times[1].time_to : ''
      this.model.total_day = 90
    },

    getTotalDay() {
      if (
        !this.model.employee_id ||
        !this.model.date_from ||
        !this.model.date_to ||
        !this.model.time_from ||
        !this.model.time_to
      )
        return
      this.$store.dispatch('hr/leaveRecord/getTotal', this.model).then(response => {
        this.model.total_day = response.data
      })
    },

    tConvert(time) {
      if (time === null || time === undefined) return null
      // Check correct time format and split into components
      time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time]

      if (time.length > 1) {
        // If time format correct
        time = time.slice(1) // Remove full string match value
        time[5] = +time[0] < 12 ? ' AM' : ' PM' // Set AM/PM
        time[0] = +time[0] % 12 || 12 // Adjust hours
      }
      return time.join('') // return adjusted time or original string
    },

    async fetchResourceBeforeCreate() {
      this.loadingPreData = true
      await Promise.all([this.fetchEmployees(), this.fetchLeaveSubItems()]).then(() => {})
      await this.$store
        .dispatch('hr/leaveRecord/dataBeforeCreate')
        .then(() => {
          this.setEditData()
          this.loadingPreData = false
        })
        .catch(error => {
          this.loadingPreData = false
          this.$toasted.error(error.message)
        })
    },
    getEmployee(employee_id) {
      if (employee_id === null || employee_id === undefined) return

      let employee = this.employees.find(e => e.employee_id == employee_id)

      if (employee === null || employee === undefined) return
      this.profile.card_id = employee.card_id
      this.profile.employee_name_en = employee.employee_name_en
      this.profile.employee_name_kh = employee.employee_name_kh
      this.profile.sex = employee.sex
      this.profile.position_name_en = employee.logical_position ? employee.logical_position.position_name_en : ''
      this.profile.shift_name = employee.shift ? employee.shift.shift_name + '(' + employee.shift.shift_type + ')' : ''
      this.profile.date_of_birth = employee.date_of_birth
      this.profile.photo = employee.photo
      this.profile.phone = employee.phone
      this.getTimeFromTo(this.model)
      this.getTotalDay()
    },
    photoEmp(record) {
      if (!this.model.employee_id) return this.user_default
      if (record.photo) {
        return record.photo + '&api_token=' + this.$store.getters.accessToken
      }
      return record.sex == 'Male' ? this.manPhoto : this.womenPhoto
    },

    onError(record) {
      event ? (event.target.src = record.sex == 'Male' ? this.manPhoto : this.womenPhoto) : ''
    },
    update() {
      this.errors = new Errors()
      this.saving = true
      this.$store
        .dispatch('hr/leaveRecord/update', {
          id: this.edit_data.lr_id,
          data: this.model
        })
        .then(response => {
          this.$toasted.success(response.message)
          this.$router.push({ name: 'leave-record' })
        })
        .catch(error => {
          this.saving = false
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
    },
    setEditData() {
      this.model = {
        lr_id: this.edit_data.lr_id,
        employee_id: this.edit_data.employee_id,
        leave_type_id: this.edit_data.leave_type_id,
        leave_sub_item_id: this.edit_data.leave_sub_item_id,
        date_from: this.edit_data.date_from,
        date_to: this.edit_data.date_to,
        time_from: this.edit_data.time_from,
        time_to: this.edit_data.time_to,
        total_day: this.edit_data.total_day,
        leave_reason: this.edit_data.leave_reason
      }
      this.getEmployee(this.edit_data.employee_id)
    }
  },
  watch: {
    'model.leave_type_id': function() {
      this.onLeaveType()
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('hr/leaveRecord/RESET_STATE')
    next()
  }
}
</script>
<style scoped>
#cover-image img {
  object-fit: contain;
  width: 100%;
  height: 100%;
}
.section-divider {
  border-bottom: 1px solid #eee;
  margin-bottom: 10px;
}
.list-group-item {
  border: none !important;
  padding: 15px 0 15px 0;
  margin: 0;
  border-top: 1px solid #eee !important;
}
.list-group-item.address {
  border: none !important;
  padding-top: 2px;
}
.text-uppercase {
  text-transform: uppercase !important;
}
#img-frame {
  display: block;
  position: relative;
  margin: -19%;
}
#img-frame img {
  object-fit: contain;
  width: 20%;
  height: 20%;
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 3px;
  margin: 0 auto;
}
table td {
  vertical-align: middle;
}
::-webkit-scrollbar {
  height: 8px;
  width: 3px; /* Remove scrollbar space */
  background: #ffff; /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #e5e7e7;
}
div::-webkit-scrollbar-thumb:hover {
  background: #b7b7b8;
}
</style>
